import React, { CSSProperties } from 'react'
import { Typography, Button, TableCell, Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface BasicSystemTableMonthCellProps {
  isCellHeaderEmpty: boolean
  month: {
    monthData?: {
      fixAvailable: number
    }
  }
  fixAvailableCount: number
  fixButtonDisabled: boolean
  flexButtonDisabled: boolean
  fixButtonActive: boolean
  flexButtonActive: boolean
  fixButtonHighlight: boolean
  flexButtonHighlight: boolean
  onFixClick: () => void
  onFlexClick: () => void
}

const useStyles = makeStyles()(theme => ({
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
  },
  tableNoBorder: {
    border: 'none',
  },
  fixFlexButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    '&.Mui-disabled': {
      color: theme.palette.shades.shade02,
    },
  },
  fixFlexActive: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  highlightMonthBorder: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}))

/*
 * Month cell Layout for Basic System Fix/Flex actions
 */
const BasicSystemTableMonthCell: React.FC<BasicSystemTableMonthCellProps> = ({
  isCellHeaderEmpty,
  month,
  fixAvailableCount,
  fixButtonDisabled,
  flexButtonDisabled,
  fixButtonActive,
  flexButtonActive,
  fixButtonHighlight,
  flexButtonHighlight,
  onFixClick,
  onFlexClick,
}) => {
  const { classes, cx } = useStyles()
  const { t } = useCustomTranslation()
  const cellStyle: CSSProperties = isCellHeaderEmpty ? { minWidth: '120px' } : {}

  return (
    <TableCell sx={{ maxWidth: '150px' }} className={classes.tableNoBorder} style={cellStyle}>
      {isCellHeaderEmpty ? null : (
        <Typography variant="h5">
          {month ? (
            <Box className={classes.buttonContainer}>
              <Button
                className={cx(classes.fixFlexButton, fixButtonHighlight && classes.highlightMonthBorder, fixButtonActive && classes.fixFlexActive)}
                sx={{ margin: 0, whiteSpace: 'nowrap' }}
                variant="text"
                onClick={onFixClick}
                disabled={fixButtonDisabled}
              >
                {fixAvailableCount} {t('shop.common.fix')}
              </Button>

              <Typography>|</Typography>

              <Button
                className={cx(classes.fixFlexButton, flexButtonHighlight && classes.highlightMonthBorder, flexButtonActive && classes.fixFlexActive)}
                sx={{ margin: 0, whiteSpace: 'nowrap' }}
                variant="text"
                onClick={onFlexClick}
                disabled={flexButtonDisabled}
              >
                {t('shop.common.flex')}
              </Button>
            </Box>
          ) : (
            <Box className={classes.buttonContainer}>
              <Button className={cx(classes.fixFlexButton)} sx={{ margin: 0, whiteSpace: 'nowrap' }} variant="text" disabled>
                {`0 ${t('shop.common.fix')}`}
              </Button>

              <Typography>|</Typography>

              <Button className={classes.fixFlexButton} sx={{ margin: 0, whiteSpace: 'nowrap' }} variant="text" disabled>
                {t('shop.common.flex')}
              </Button>
            </Box>
          )}
        </Typography>
      )}
    </TableCell>
  )
}

export default BasicSystemTableMonthCell
